import { createSlice } from '@reduxjs/toolkit';




const initialState = {
  departments:[]
};
export const  departmentsDetailById =(id)=>{
  // let product = initialState.departments.find((item)=>item.id+""===id+"")
  // return product
}

export const departmentsSlice = createSlice({
  name: 'departments',
  initialState,
  reducers: {
    setDepartments: (state, { payload }) => {
     
      state.departments = [...payload];
    },
    
    
   
    clearDepartmentsState: (state) => {
      state=initialState
    }
  }
});

export const { setDepartments, clearDepartmentsState } = departmentsSlice.actions;

export const departmentsData = (state) => state.departments;


export default departmentsSlice.reducer;
